<template>
    <div class="form-item">
        <el-popover ref="shortcutPopover" placement="left-start" width="100" trigger="click" v-model="shortcutPopoverVisible">
            <div class="parameter-title font-bold">最近...</div>
            <ul class="parameter-list">
                <li class="parameter-item shortcut-item" v-for="(recentDateItem, index) in recentDateItems" :key="recentDateItem[0]" @click="applyShortcutDates(recentDateItem[0])">
                    <div class="parameter-txt" :class="{'shortcut-item-sepline' : index < recentDateItems.length-1}">
                        <label style="display:inline-block;vertical-align: middle;">
                            <span>{{ recentDateItem[1] }}</span>
                        </label>
                    </div>
                </li>
            </ul>
        </el-popover>
        <div class="form-label">
            <label v-if="label != null">{{ label }}</label>
        </div>
        <div class="form-value" style="width: 446px;">
            <label><input :disabled="disabled" type="checkbox" v-model="useFrom" @change="syncModel"/> 从</label>
            <el-date-picker :type="dateType" :style="getStyle()" :disabled="disabled || !useFrom" v-model="curValue.from" :format="format" :value-format="format" @change="syncModel"></el-date-picker>
            <label><input :disabled="disabled" type="checkbox" v-model="useTo" @change="syncModel"/> 至</label>
            <el-date-picker :type="dateType" :style="getStyle()" :disabled="disabled || !useTo" v-model="curValue.to" :format="format" :value-format="format" @change="syncModel"></el-date-picker>
            <i v-if="!disabled" class="icon iconfont icon-edit" style="cursor:pointer" v-popover:shortcutPopover></i>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'

    //有效的值类型
    let validValueTypes_datetime = ['String', 'Date'];
    let validValueTypes_puredate = ['String', 'Date', 'Integer'];

    function isValidValueType(valueType, withTime) {
        let validValueTypes = withTime ? validValueTypes_datetime : validValueTypes_puredate;
        return validValueTypes.indexOf(valueType) != -1;
    }

    //转成按yyyy-MM-dd格式显示的文本
    export function formatIntegerDate(dateVal, format) {
        //console.log(dateVal);
        if (dateVal == null) {
            return null;
        }
        format = format || 'yyyy-MM-dd';
        if (Utils.isDate(dateVal)) {
            return dateVal.format(format);
        }
        let dateStr = dateVal + '';
        if (Utils.isNoB(dateStr)) {
            return null;
        }
        if (Utils.isNumStr(dateStr, 0) && dateStr.length >= 8) {
            dateStr = dateStr.substring(0, 8);
            return dateStr.substring(0, 4) + '-' + dateStr.substring(4, 6) + '-' + dateStr.substring(6);
        } else {
            return dateStr;
        }
    }

    function parseDateByValueType(dateVal, valueType) {
        if (valueType == 'Integer') {
            dateVal = formatIntegerDate(dateVal);
        }
        return typeof dateVal == 'string' ? Date.parseAsDate(dateVal) : dateVal;
    }

    function getModelResultValue(curValue, valueType, format) {
        let resultValue = curValue;
        if (resultValue != null) {
            resultValue = Date.parseAsDate(resultValue);
            //
            if (Utils.isDate(resultValue)) {
                if (valueType == 'String') {
                    resultValue = resultValue.format(format);
                } else if (valueType == 'Integer') {
                    resultValue = Utils.ParseInt(resultValue.format('yyyyMMdd'));
                }
            }
        }
        return resultValue;
    }

    function makeRecentDateItems() {
        return [['week', '一周'], ['month', '一个月份'], ['quarter', '一个季度'], ['year', '一年']];
    }

    function makeRecentDateRange(code) {
        let dateTo = new Date();
        let dateFrom = null;
        switch (code) {
            case 'week' :
                dateFrom = dateTo.addDays(-6);
                break;
            case 'month' :
                dateFrom = dateTo.addMonths(-1);
                break;
            case 'quarter' :
                dateFrom = dateTo.addQuarters(-1);
                break;
            case 'year' :
                dateFrom = dateTo.addYears(-1);
                break;
            default :
                dateFrom = dateTo;
                break;
        }
        //
        return {
            from: dateFrom,
            to: dateTo
        };
    }

    //
    export default {
        name: 'swb-query-date2-field',
        //
        props: {
            valueType: {
                type: String,
                default: 'String'
            },
            label: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            time: {//是否使用时间部分
                //type: Boolean,
                default: false
            },
            iniValue: {
                default: null
            }
        },
        //
        data() {
            return {
                dateType: 'date',
                format: 'yyyy-MM-dd',
                //
                useFrom: false,
                useTo: true,
                //
                curValue: {
                    from: null,
                    to: null
                },
                recentDateItems: makeRecentDateItems(),
                shortcutPopoverVisible: false
            };
        },
        watch: {
            valueType(newVal, oldVal) {
                this.init();
            },
            iniValue(newVal, oldVal) {
                this.init();
            }
        },
        //
        created() {
            this.init();
        },
        beforeDestroy() {
            //data
            this.curValue = null;
            this.recentDateItems = null;
        },
        //
        methods: {
            getStyle() {
                return this.dateType == 'datetime' ? {width: '170px'} : {width: '170px'};
            },
            init() {
                this.dateType = this.time == true ? 'datetime' : 'date';
                this.format = this.dateType == 'datetime' ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd';
                //
                if (!isValidValueType(this.valueType, this.time)) {
                    let validValueTypes = this.time ? validValueTypes_datetime : validValueTypes_puredate;
                    let message = '组件的值类型有误，可用的值类型为：' + validValueTypes.join(", ");
                    if (typeof Toast !== 'undefined') {
                        Toast.show(message, 3000, 'error');
                    } else {
                        MsgBox.error(message);
                    }
                }
                //
                let today = new Date();
                //
                this.curValue = {
                    from: today.addMonths(-1).addDays(1),
                    to: today
                };
                //
                let iniValue = this.iniValue || {};
                this.useFrom = iniValue.from != null;
                this.useTo = iniValue.to != null;
                //初始化
                if (typeof iniValue.from != 'undefined') {
                    iniValue.from = parseDateByValueType(iniValue.from);
                }
                if (typeof iniValue.to != 'undefined') {
                    iniValue.to = parseDateByValueType(iniValue.to);
                }
                this.curValue = Utils.merge(this.curValue, iniValue);
                this.syncModel();
            },
            applyShortcutDates(shortcutDateCode) {
                this.shortcutPopoverVisible = false;
                //
                this.curValue = makeRecentDateRange(shortcutDateCode);
                //
                this.syncModel();
            },
            syncModel() {
                let resultValue = {};
                if (this.useFrom) {
                    resultValue.from = getModelResultValue(this.curValue.from, this.valueType, this.format);
                }
                if (this.useTo) {
                    resultValue.to = getModelResultValue(this.curValue.to, this.valueType, this.format);
                }
                //
                this.$emit('input', resultValue);
                //
                this.$emit('valueformat', this.format);
            }
        }
    }

</script>

<style scoped>

    .shortcut-item:hover {
        background-color: #FFEFC1;
    }

    .shortcut-item-sepline {
        border-bottom: 1px dashed #d7d4f0;
    }

</style>



// WEBPACK FOOTER //
// src/compo/query/QueryDate2Field.vue